import React, { ReactNode } from "react";
import cx from "classnames";

import styles from "./Label.module.scss";

interface Props {
  variant: "l1" | "l2" | "l3" | "l4",
  light?: boolean,
  children: ReactNode,
  className?: string,
};

export function Label({
  variant,
  light,
  children,
  className,
}: Props) {
  return (
    <p
      className={cx(styles.Label, className, {
        [styles.l1]: variant === "l1",
        [styles.l2]: variant === "l2",
        [styles.l3]: variant === "l3",
        [styles.l4]: variant === "l4",
        [styles.light]: light,
      })}
    >
      {children}
    </p>
  );
}

